
import { ListItemText, Typography, Box, ListItemButton, IconButton, Divider, ListSubheader, Tooltip, InputBase, } from "@mui/material";
import { useEffect, useState } from "react";
import { AddOutlined, ClearOutlined, FilterListOutlined, ListAltOutlined, ReceiptLongOutlined } from "@mui/icons-material";
import apis from "../../../api";
import { getUserSession } from "../../../Utils/Common";
import { getItemsFromObjects } from "../../../Component/DataLoader";
import { MemberItem } from "../../member/fragement/MemberItems";

const CourseMembers = (props) => {
    const [datas, setDatas] = useState([])
    const [memberFilter, setMemberFitler] = useState()
    getUserSession(apis)
    const [curIdx1, setCurIdx] = useState()
    const { courses, courseMembers, filtMemberCourses, title, onAddMember, onClick, selected } = props
    const [filtList, setFiltList] = useState([])
    const [clickItem, setClickItem] = useState()

    useEffect(() => {
        setDatas(courseMembers)
    }, [courseMembers])
    useEffect(() => {
        let cc = []
        for (let i = 0; i < filtMemberCourses?.length; i++) {
            cc.push(filtMemberCourses[i]?.id)
        }
        setFiltList(cc)
    }, [filtMemberCourses])
    useEffect(() => {
        setClickItem(selected)
    }, [selected])
    const handleMouseOver = (idx) => {
        setCurIdx(idx)
    }
    const handleOrderView = (idx, item) => {
        window.open('/member/course/' + item.member?.id+"/"+item.course_package?.category_id,"order")
    }
    const handleBillView = (idx, item) => {
        window.open('/member/balancelog/' + item.member.user_id + "/0","bill")
    }
    const handleAddMember = (idx1, item) => {
        onAddMember && onAddMember(item)
    }
    const handlClickItem = (idx1, item) => {
        if (clickItem?.member_id == item.member?.id && clickItem?.member_course_id == item.id) {
            setClickItem()
            onClick && onClick()
        } else {
            setClickItem({ member_id: item.member?.id, member_course_id: item.id })
            onClick && onClick({ member_id: item.member?.id, member_course_id: item.id, member: item.member, member_course: item })
        }
    }

    return datas && <Box sx={{ border: "1px solid #8882" }}>
        {title && <ListSubheader component="div">
            <Box sx={{ display: "flex", pt: 1, pb: 1 }}>
                <Typography sx={{ fontSize: "inherit", mt: 0.5, mr: 5 }}>{title} ({datas.length})</Typography>
                <InputBase sx={{ ml: 1, flex: 1, fontSize: 'inherit' }} placeholder="Search member" value={memberFilter} onChange={(e) => { setMemberFitler(e.target.value) }}
                    inputProps={{ 'aria-label': 'search member' }} />
                {memberFilter && <ClearOutlined fontSize="inherit" sx={{ mt: 0.9, cursor: "pointer" }} onClick={() => { setMemberFitler() }} />}
                <FilterListOutlined fontSize="inherit" sx={{ mt: 0.9 }} />
            </Box>
        </ListSubheader>}
        {datas.map((item, idx1) => {
            if (filtList.indexOf(item.id) >= 0) {
                return
            } else if (memberFilter && item.member.name.toLowerCase().indexOf(memberFilter.toLowerCase()) < 0) {
                return
            }
            let course = item.course_package?.course_id > 0 && getItemsFromObjects(courses, item.course_package.course_id)
            let lessons = (item.course_package?.billtype == 1) ? ((item.remained / 60).toFixed(1) + " hours") : (item.remained + " lessons (" + ((item.course_package?.minutes) / 60).toFixed(1) + " h)")
            return <Box key={idx1} ><ListItemButton selected={clickItem?.member_id == item.member?.id && clickItem?.member_course_id == item.id} onClickCapture={() => handlClickItem(idx1, item)} onMouseEnter={() => { handleMouseOver(idx1) }} onClick={() => { }}>
                <ListItemText primary={
                    <Box sx={{ display: "flex" }}>
                        <MemberItem member={item?.member} sx={{mt:0.5,mr:0.5}}/>
                        {idx1 == curIdx1 && <Tooltip title="Course orders"><IconButton size="small" onClick={() => { handleOrderView(idx1, item) }}><ListAltOutlined fontSize="inherit" /></IconButton></Tooltip>}
                        {idx1 == curIdx1 && <Tooltip title="Transaction logs"><IconButton size="small" onClick={() => { handleBillView(idx1, item) }}><ReceiptLongOutlined fontSize="inherit" /></IconButton></Tooltip>}
                    </Box>}
                    secondary={<Typography sx={{ color: "gray", fontSize: '12px' }}>{course?.name} / {lessons}</Typography>}
                />
                {idx1 == curIdx1 && <IconButton aria-label="Add" size="small" onClick={() => { handleAddMember(idx1, item) }}><AddOutlined fontSize="inherit" /></IconButton>}
            </ListItemButton>
                <Divider />
            </Box>
        })}

    </Box>
}
export default CourseMembers